import React, { useEffect } from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Edit from '@material-ui/icons/Edit';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Grid } from '@material-ui/core';

const EditConveniosButton = ({ idItem, item, editItem }) => {
    const [open, setOpen] = React.useState(false);
    const [valor, setValor] = React.useState(item.valor);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(false)
        editItem(idItem, {
            valor,
        });
    }

    useEffect(() => {
        setValor(item.valor);
    }, [idItem]);

    return (
        <>
            <Button
                color="primary"
                size={"large"}
                startIcon={<Edit />}
                onClick={handleClickOpen}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <ValidatorForm onSubmit={handleSubmit}>
                    <DialogTitle id="alert-dialog-title">{"Editar valorización"}</DialogTitle>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextValidator
                                    label="Valor"
                                    margin="normal"
                                    fullWidth
                                    autoComplete="off"
                                    value={valor}
                                    onChange={(e) => setValor(e.target.value)}
                                    validators={["isFloat"]}
                                    errorMessages={["Solo numeros"]}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button type="button" onClick={handleClose} color="primary">
                            Cancelar
                        </Button>
                        <Button type="submit" color="primary" autoFocus>
                            Aceptar
                        </Button>
                    </DialogActions>
                </ValidatorForm>
            </Dialog>
        </>
    )
}

export default EditConveniosButton
